$(document).ready(function() {
    $(".vehicle-make").change(function(e) {
        $(".vehicle-model").html("<option>Select Model</option>");
        $(".vehicle-year").html("<option>Select Year</option>");
        $.ajax({
            url: "/vehicles/lookup",
            method: "get",
            dataType: "json",
            data: {
                "make_id": $(this).val()
            },
            success: function(r) {
                var html = "<option>Select Model</option>";
                $.each(r, function() {
                    html += "<option value='" + this.id + "'>" + this.name + "</option>";
                });
                $(".vehicle-model").html(html);
            }
        });
    });

    $(".vehicle-model").change(function(e) {
        $(".vehicle-year").html("<option>Select Year</option>");
        $.ajax({
            url: "/vehicles/lookup",
            method: "get",
            dataType: "json",
            data: {
                "make_id": $(".vehicle-make").val(),
                "model_id": $(this).val(),
            },
            success: function(r) {
                var html = "<option>Select Year</option>";
                $.each(r, function() {
                    html += "<option value='" + this.id + "'>" + this.name + "</option>";
                });
                $(".vehicle-year").html(html);
            }
        });
    });
});
